import { Component, inject, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { BannerComponent } from '../banner/banner.component';
import { CoursesSectionComponent } from '../courses-section/courses-section.component';
import { TestimonialsComponent } from '../testimonials/testimonials.component';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from "../../../shared/header/header.component";
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Category } from '../../../models/category';
import { CategoryService } from '../../../services/category/category.service';
import { AuthService } from '../../../services/auth/auth.service';
import { CartService } from '../../../services/cart/cart.service';
import { firstValueFrom } from 'rxjs';
import {scrollTo} from '../../../utils/utils';
import { CategoryCardAction } from '../../../enums/categoryCardAction.enum';
import { MiddleBannerComponent } from '../middle-banner/middle-banner.component';

@Component({
  selector: 'app-homepage',
  standalone: true,
  imports: [
    SharedModule,
    BannerComponent,
    CoursesSectionComponent,
    TestimonialsComponent,
    FooterComponent,
    HeaderComponent,
	MiddleBannerComponent,
	RouterModule
],
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss'
})
export class FootballLmsHomepageComponent implements OnInit {

  categories: Category[] = [];

  authService = inject(AuthService);
  categoryService = inject(CategoryService);
  cartService = inject(CartService);
  activatedRoute = inject(ActivatedRoute);
  currentCartCategoriesId: string[];

  async ngOnInit(): Promise<void> {
    const goToCourses = this.activatedRoute.snapshot.queryParams['courses'];
    if(goToCourses){
      scrollTo('courses-section');
    }

    await this.loadCategories();
    await this.loadCart();
    if (this.categories?.length){
      this.categories.forEach(category => {
        category.__categoryCardAction = this.currentCartCategoriesId.includes(category.id) ? CategoryCardAction.IN_CART : CategoryCardAction.AVAILABLE;
      });
    }
  }

  async loadCategories() {
    this.categories = await this.categoryService.getRecentCategories(this.authService.projectId, 12);
  }

  async loadCart(): Promise<void> {
    await this.cartService.loadCartAndCategories(this.authService.projectId)
    let cart = await firstValueFrom(this.cartService.cart$);
    this.currentCartCategoriesId = cart.items.map(item => item.id);
  }

}
